interface MetaData {
  title: string;
  description: string;
  url: string;
  imageUrl?: string;
  type?: string;
  publishedAt?: string;
  modifiedAt?: string;
}

export function OrganizationJsonLD() {
  const data = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "福利导航",
    url: "https://fulidaohang.com",
    description:
      "一站式福利资源聚合平台，为您精准汇聚购物优惠、会员权益、生活补贴、职场福利等多维度福利信息。",
    email: "contact@fulidaohang.com",
    telephone: "+86-400-888-8888",
    address: {
      "@type": "PostalAddress",
      streetAddress: "建国路88号",
      addressLocality: "北京",
      addressRegion: "朝阳区",
      addressCountry: "CN",
    },
    sameAs: [
      "https://weibo.com/fulidaohang",
      "https://weixin.qq.com/fulidaohang",
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function WebSiteJsonLD() {
  const data = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "福利导航",
    url: "https://fulidaohang.com",
    description:
      "福利导航为您精准汇聚海量福利资源，涵盖购物优惠、会员权益、生活补贴、职场福利等多维度内容。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://fulidaohang.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function WebPageJsonLD({ title, description, url }: MetaData) {
  const data = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    url,
    inLanguage: "zh-CN",
    isPartOf: {
      "@type": "WebSite",
      name: "福利导航",
      url: "https://fulidaohang.com",
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function ArticleJsonLD({
  title,
  description,
  url,
  imageUrl,
  publishedAt,
  modifiedAt,
}: MetaData) {
  const data = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    url,
    image: imageUrl || "https://fulidaohang.com/og-image.jpg",
    datePublished: publishedAt,
    dateModified: modifiedAt || publishedAt,
    author: {
      "@type": "Organization",
      name: "福利导航",
      url: "https://fulidaohang.com",
    },
    publisher: {
      "@type": "Organization",
      name: "福利导航",
      url: "https://fulidaohang.com",
    },
    inLanguage: "zh-CN",
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function FAQPageJsonLD({
  questions,
}: {
  questions: { question: string; answer: string }[];
}) {
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map((q) => ({
      "@type": "Question",
      name: q.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: q.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}